export const state = {
    user: {},
    token: null,
};

export const mutations = {
    SET_LOGGED_USER(state, user){
        console.log("SET_LOGGED_USER ", user);
        state.user = user;
    },
    SET_LOGGED_TOKEN(state, token){
        console.log("SET_LOGGED_TOKEN ", token);
        state.token = token;
    },
    UPDATE_USER_FIELD(state, { field, value }) {
        if (state.user) {
            state.user = { ...state.user, [field]: value }; // Crea una nueva copia reactiva
            localStorage.setItem('user', JSON.stringify(state.user));
        }
    }
};

export const actions = {
    setLoggedUser({commit}, {user, token}){
        console.log("setLoggedUser-user: ", user);
        console.log("setLoggedUser-token: ", token);
        commit('SET_LOGGED_USER', user);
        commit('SET_LOGGED_TOKEN', token);
    },
    // setLoggedUser(state, { user, token }) {
    //     console.log("user ", user);
    //     console.log("token ", token);
    //     state.user = user;
    //     state.token = token;
    // },
    hydrateFromStorage({ commit }) {
        // console.log("hydrateFromStorage");
        const userString  = localStorage.getItem('user')
        const token = localStorage.getItem('jwt')
        // console.log("user: ", userString);
        // console.log("jwt: ", token);
        if (userString && token) {
            const user = JSON.parse(userString)
            commit('SET_LOGGED_USER', user);
            commit('SET_LOGGED_TOKEN', token);
        }
    }
};
